module.exports = "/src/views/games/other/images/maps/tanks1.png";